import React, { useEffect, useState } from "react";
import ApiService from "../../../../services/ApiService";
import AuthPage from "./AuthPage";

// Message passed from this popup back to the framed app that opened it (same origin only).
export const REVIEW_TOKEN_MESSAGE = "bb-review-signin";

/**
 * Opened as a popup by AuthPage when the app is framed by the Landmark Review platform.
 * Browsers give framed pages their own storage, so the framed copy can't see the sign-in
 * this browser already has. This page runs first-party, checks that sign-in, and hands the
 * session token to the opener. postMessage is addressed to this origin, so only another
 * copy of this app can receive it.
 */
const ReviewSignIn = () => {
  const [state, setState] = useState("checking"); // checking | sent | signin | orphan

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("token");
      const hasToken = token && token !== "null" && token !== "undefined";
      const me = hasToken ? await new ApiService().get("landmark/employees/auth/me") : null;
      if (!me || !me.success) {
        setState("signin");
        return;
      }
      if (!window.opener || window.opener.closed) {
        setState("orphan");
        return;
      }
      window.opener.postMessage({ type: REVIEW_TOKEN_MESSAGE, token }, window.location.origin);
      setState("sent");
      setTimeout(() => window.close(), 400);
    })();
  }, []);

  if (state === "signin") return <AuthPage />;
  return (
    <div className="landmark-sign-in">
      <div className="card">
        <div className="card-body">
          <div className="header-text mb-2">Landmark Review</div>
          <p className="mb-0">
            {state === "checking" && "Checking your sign-in…"}
            {state === "sent" && "Signed in. You can close this window."}
            {state === "orphan" &&
              "You're signed in. Go back to the review and press \"Use my Better Blocks sign-in\" again."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewSignIn;
